import { pickBy, round, sum, get, min, max, includes } from 'lodash'
import Cookies from 'js-cookie'
export const calColor = gs => {
  let h = gs * gs * 0.0105
  let s = 85
  let l = 65 - gs * gs * 0.0024
  return `hsl(${h}, ${s}%, ${l}%)`
}

export const JSONToFormData = function(obj, form, namespace) {
  var fd = form || new FormData()
  var formKey

  for (var property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (namespace) {
        formKey = namespace + '[' + property + ']'
      } else {
        formKey = property
      }

      // if the property is an object, but not a File,
      // use recursivity.
      if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
        JSONToFormData(obj[property], fd, property)
      } else {
        // if it's a string or a File object
        fd.append(formKey, obj[property])
      }
    }
  }

  return fd
}

export const gsCalculator = (items = {}) => {
  const greenScore = {
    animalWelfare: get(items, 'animalWelfare', null),
    environment: get(items, 'environment', null),
    foodSafety: get(items, 'foodSafety', null),
    nutrition: get(items, 'nutrition', null),
    processing: get(items, 'processing', null),
    transparency: get(items, 'transparency', null),
    humanRights: get(items, 'humanRights', null)
  }
  const data = Object.values(pickBy(greenScore, o => o !== null && o !== ''))
  return round(sum(data) / data.length)
}

export const roudingValue = value => {
  return value ? value.toFixed(2) : 'na.na'
}

export const priceRangeCalculator = priceRange => {
  // console.log('priceRange', priceRange)
  if (min(priceRange) === max(priceRange)) {
    const minRange = min(priceRange)
    // return `$${min(priceRange)}`
    return `$${roudingValue(minRange)}`
  } else {
    const minRange = min(priceRange)
    const maxRange = max(priceRange)
    // return `$${min(priceRange) || 0} - $${max(priceRange) || 0}`
    return `$${roudingValue(minRange) || 0} - $${roudingValue(maxRange) || 0}`
    // const minRange = min(priceRange)
  }
}

export const priceRangeCalculatorNew = (priceRange, userZipcode) => {
  // console.log('priceRange', priceRange, userZipcode)
  const filteredPriceRange = priceRange.filter(item => item.zipCode === userZipcode).map(item => item.value)
  let priceNewRange = []
  if (filteredPriceRange.length === 0) {
    priceNewRange = priceRange.map(item => item.value)
  } else {
    priceNewRange = filteredPriceRange
  }
  if (min(priceNewRange) === max(priceNewRange)) {
    const minRange = min(priceNewRange)
    // return `$${min(priceRange)}`
    return `$${roudingValue(minRange)}`
  } else {
    const minRange = min(priceNewRange)
    const maxRange = max(priceNewRange)
    // return `$${min(priceRange) || 0} - $${max(priceRange) || 0}`
    return `$${roudingValue(minRange) || 0} - $${roudingValue(maxRange) || 0}`
    // const minRange = min(priceRange)
  }
}

function capitalize(token) {
  token = String(token)
  return token.charAt(0).toUpperCase() + token.substring(1)
}

export const showHeaderFromUrl = pathname => {
  if (pathname === '/best-for-you') {
    return 'Best for You'
  } else if (pathname === '/best-scores') {
    return 'Best Scores'
  } else if (pathname === '/favorites') {
    return 'All Favorites'
  } else if (pathname === '/recently-searched') {
    return 'Recently Viewed'
  } else {
    return 'Page Not Found'
  }
}

export const isAdmin = () => {
  const userEmail = Cookies.getJSON('userDetails').email
  if (
    userEmail === 'harshmaur@gmail.com' ||
    userEmail === 'galenkm@greenchoicenow.com' ||
    userEmail === 'varuns@greenchoicenow.com'
  ) {
    return true
  } else {
    return false
  }
}

export const wordCount = str => {
  const arrStr = str.split(' ')
  var i
  for (i = 0; i < arrStr.length; i++) {
    if (i === 1) {
      break
    }
    if (get(arrStr, '[0].length', 0) > 5 && get(arrStr, '[1].length', 0) > 8) {
      return true
    } else {
      return false
    }
  }
}

export const filterHiddenData = data => {
  if (isAdmin()) {
    return data
  } else {
    return data.filter(item => item.isHidden === false)
  }
}

export const upperlower = function(source, notation = 'capitalize', isHyphenated = false) {
  // only convert strings and arrays
  if (!(typeof source === 'string' || Array.isArray(source))) {
    console.error(`[upperlower] Source must be a <string> or an <array>, instead a <${typeof source}> was given.`)
    return
  }

  if (typeof source === 'string') source = source.split(isHyphenated ? /[_.\-]+/ : /\s+/)

  let output = []
  let separator = ''
  switch (notation) {
    case 'hyphenate':
      separator = '-'
      output = source
      break

    case 'kebapcase':
      separator = '-'
      output = source.map(token => token.toLowerCase())
      break

    case 'pascalcase':
      output = source.map(token => capitalize(token))
      break

    case 'camelcase':
      output = output.concat(source.shift(), source.map(token => capitalize(token)))
      break

    case 'allcaps':
      separator = ' '
      output = source.map(token => capitalize(token))
      break

    case 'titlecase':
      separator = ' '
      let trivials = [
        'a',
        'an',
        'the',
        'and',
        'or',
        'but' /* "nor", "for", "so", "yet" */,
        'on',
        'in',
        'at',
        'by',
        'for',
        'of',
        'off',
        'to',
        'up'
      ]
      output = output.concat(
        capitalize(source.shift()),
        source.map(token => {
          return token.length > 3 || !trivials.includes(token.toLowerCase()) ? capitalize(token) : token.toLowerCase()
        })
      )
      break

    case 'capitalize':
    default:
      separator = ' '
      source[0] = capitalize(source[0])
      output = source
  }

  return output.join(separator)
}



// WEBPACK FOOTER //
// ./src/utlis/functions.js